// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__BPwnK","tab":"tabs_tab__eXDUF","tabsActive":"tabs_tabsActive__KGYuF"};